import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

const DashboardCharts = ({ faturamentoPorMes }) => (
  <div className="lg:col-span-2 bg-white rounded-xl border border-slate-200 shadow-sm p-5">
    <p className="text-xs font-bold uppercase tracking-wide text-slate-400 mb-1">Faturamento Mensal</p>
    <p className="text-sm font-black text-slate-800 mb-4">{new Date().getFullYear()}</p>
    <ResponsiveContainer width="100%" height={180}>
      <BarChart data={faturamentoPorMes} margin={{ top: 0, right: 10, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" />
        <XAxis dataKey="mes" tick={{ fontSize: 11, fontWeight: 700 }} />
        <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `R$${(v / 1000).toFixed(0)}k`} />
        <Tooltip formatter={v => brl(v)} labelStyle={{ fontWeight: 700 }} />
        <Bar dataKey="valor" fill="#0A3D73" radius={[4, 4, 0, 0]} name="Faturamento" />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export default DashboardCharts;
